import React from "react";
import { Link } from "react-router-dom";
import { CmsText } from "../../../../RichTextContent/RichTextContent";
import "./HostingPlans.css";
import { useServiceSection } from "../../../../../context/ServicePageContext";
import { getHostingPlansFromSection } from "../../../../../services/contentApi";
import { stripRichText } from "../../../../../utils/richText";
import checkIcon from "../../../../../assets/images/services/check.png";

function planSlugFromName(name) {
  return stripRichText(name)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

function hostingOrderLink(buttonLink, planName) {
  const base = (buttonLink || "/orderhost").trim() || "/orderhost";
  const slug = planSlugFromName(planName);
  if (!slug) return base;

  try {
    const url = new URL(base, window.location.origin);
    url.searchParams.set("plan", slug);
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    const joiner = base.includes("?") ? "&" : "?";
    return `${base}${joiner}plan=${encodeURIComponent(slug)}`;
  }
}

const HostingPlans = () => {
  const { section, loading } = useServiceSection("hosting-plans");

  if (loading || !section?.fields) return null;

  const fields = section.fields;
  const { popularBadge, plans } = getHostingPlansFromSection(section);

  return (
    <section className="hosting">
      <div className="hosting__container">
        {fields.label ? (
          <CmsText
            content={fields.label}
            as="span"
            className="hosting__label"
          />
        ) : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h2" />
        ) : null}

        {fields.subtitle ? (
          <CmsText
            content={fields.subtitle}
            as="p"
            className="hosting__subtitle"
          />
        ) : null}

        <div className="hosting__grid">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`hosting__card ${plan.popular ? "popular" : ""}`}
            >
              {plan.popular ? (
                <div className="hosting__badge">
                  <CmsText content={popularBadge} as="span" />
                </div>
              ) : null}

              <div className="hosting__card-body">
                <CmsText
                  content={plan.name}
                  as="span"
                  className="hosting__name"
                />
                <CmsText content={plan.price} as="h3" />

                {plan.billing ? (
                  <CmsText
                    content={plan.billing}
                    as="p"
                    className="hosting__billing"
                  />
                ) : null}

                <div className="hosting__features">
                  {plan.features.map((feature, i) => (
                    <div key={i} className="hosting__feature">
                      <img src={checkIcon} alt="" />
                      <CmsText content={feature} as="span" />
                    </div>
                  ))}
                </div>

                {plan.buttonLink ? (
                  <Link
                    to={hostingOrderLink(plan.buttonLink, plan.name)}
                    className="buttonclip hosting__btn"
                  >
                    <CmsText content={plan.buttonText} as="span" />
                  </Link>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HostingPlans;
